import { render, staticRenderFns } from "./DeviceRomAutoUploadAdminUpdateBox.vue?vue&type=template&id=28a03bb4"
import script from "./DeviceRomAutoUploadAdminUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceRomAutoUploadAdminUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports